const getSortConfig = value => {
    let field, reverse, primer;

    const textPrimer = a => a.toLowerCase();
    const floatPrimer = parseFloat;

    switch (value) {
        case 'alphaAsc':
            field = 'name';
            reverse = false;
            primer = textPrimer;
            break;
        case 'alphaDesc':
            field = 'name';
            reverse = true;
            primer = textPrimer;
            break;
        case 'priceAsc':
            field = 'firstPrice';
            reverse = false;
            primer = floatPrimer;
            break;
        case 'priceDesc':
            field = 'firstPrice';
            reverse = true;
            primer = floatPrimer;
            break;
        default:
            return null;
    }

    return { field, reverse, primer };
};

export default getSortConfig;